<app-card [titleKey]="translationKey + 'cardTitle'">
  <labeled-content [label]="translationKey + 'specialPurpose'">
    <span class="data-labels">{{
      (projectDetails().isSpecialPurposeCompanyBetweenOwnerAndInvestor
        ? "general.yes"
        : "general.no"
      ) | translate
    }}</span>
  </labeled-content>
  @if (projectDetails().isSpecialPurposeCompanyBetweenOwnerAndInvestor) {
    <div class="sub-header-wrap">
      <label class="sub-header">{{
        translationKey + "specialContact" | translate
      }}</label>
    </div>
    <app-special-entity-contacts
      [specialEntityContact]="projectDetails().legalEntitySpecialPurpose"
    />
    @if (projectDetails().personsSectionE; as person) {
      <div class="sub-header-wrap">
        <label class="sub-header">{{ "general.contactPerson" | translate }}</label>
      </div>
      <app-name-position-email-display
        [namePositionEmailData]="getPersonData(person)"
      />
    }
  }
</app-card>
